import { Box, Text } from '@pingux/astro';
import { ValidationStatus } from '@app-types/tap-partner-vault';

interface StatusBadgeProps {
  status: ValidationStatus;
  size?: 'sm' | 'md';
}

const statusConfig: Record<ValidationStatus, { bg: string; color: string; label: string }> = {
  valid: {
    bg: '#dcfce7',
    color: '#166534',
    label: 'Valid',
  },
  invalid: {
    bg: '#fee2e2',
    color: '#991b1b',
    label: 'Invalid',
  },
  pending: {
    bg: '#fef3c7',
    color: '#92400e',
    label: 'Pending',
  },
  error: {
    bg: '#fecaca',
    color: '#dc2626',
    label: 'Error',
  },
  not_applicable: {
    bg: '#f3f4f6',
    color: '#6b7280',
    label: 'N/A',
  },
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'md' }) => {
  const config = statusConfig[status] || statusConfig.pending;
  const isSmall = size === 'sm';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: isSmall ? '0.25rem' : '0.375rem',
        padding: isSmall ? '0.125rem 0.375rem' : '0.25rem 0.625rem',
        borderRadius: '9999px',
        backgroundColor: config.bg,
      }}
    >
      <Box
        sx={{
          width: isSmall ? '0.375rem' : '0.5rem',
          height: isSmall ? '0.375rem' : '0.5rem',
          borderRadius: '50%',
          backgroundColor: config.color,
        }}
      />
      <Text
        sx={{
          fontSize: isSmall ? '0.65rem' : '0.75rem',
          fontWeight: '500',
          color: config.color,
        }}
      >
        {config.label}
      </Text>
    </Box>
  );
};

export default StatusBadge;
